<template>
<div class="col-lg-4 col-md-12">
  <div class="stake-card linear-gradient-color p-3">
    <div class="stake-card__img linear-gradient-color p-2">
      <template v-if="'img' in info.asset.data">
          <img
            v-show="isImageLoaded"
            :src="getImgUrl(info.asset.data.img)"
            alt="{{info.asset.data.name}}"
            @load="loaded"
        />
        <img
          v-if="!isImageLoaded"
          :src="'/weapsmithing/images/loader.gif'"
        />
      </template>
    </div>

    <h6 class="small-text text-center">{{info.asset.data.name}}</h6>
    <div class="buttons">
      <button class="btn btn-unstake btn-block w-100" @click="reset(info)">
        Unstake
      </button>
    </div>
  </div>
  </div>
</template>

<script>
import ApiService from "@/services";
// import moment from 'moment';
import { useToast } from 'vue-toastification'
const toast = useToast()
export default {
  name: "Staked",
  props: ["rec", "row"],
  data() {
    return {
      isImageLoaded: false,
      showReadyButton: false,
      counter: "0",
      startTime:"",
      endTime:"",
      expiredDate:"",
      winningToken:0,
      hoursLeft:1,
      stakeOver: false,
    };
  },
  computed: {
    info: function () {
      return this.row;
    },
  },
  mounted() {
  },
  methods: {
    getImgUrl(pet, isVid) {
      return ApiService.getImgUrl(pet, isVid);
    },
    loaded() {
      this.isImageLoaded = true;
    },
    async reset() {
        await ApiService.resetOrClaim("resetstake",this.info.nft,((res)=>{
          if(res.processed){
            toast.success("Stake Canceled");
            setTimeout(() => {
              this.$router.go();
            }, 2000);
        }
        }),((error)=>{
          this.error = ApiService.errorFormat(error)
          toast.error(this.error);
        }));
    },
  },
};
</script>

<style>
.content {
  height: 70%;
}
.select-card {
  width: 250px;
  position: absolute;
}
.rowBlock {
  border: 1px solid black;
  border-radius: 5px;
  box-shadow: 10px 10px 14px rgba(0, 0, 0, 0.5);
  padding: 10px;
}

.rowBlock .imgBlock img {
  height: 100%;
}
.imgBlock {
  height: 100px;
}
.txtBlock h1,
h5,
.timeBlock h2 {
  color: #fff;
  text-align: center;
}
.txtBlock h1 {
  font-size: 30px;
}
.btn {
  width: 150px;
  letter-spacing: 1px;
  font-weight: bold;
  transition: all 0.4s;
  border: 2px solid #fff !important;
}
.btn:hover {
  background: white;
  color: black !important;
  transform: translateY(-4px);
  box-shadow: 10px 15px 20px rgba(0, 0, 0, 0.7);
}
.btn-cancel {
  border-radius: 4px;
  color: #fff !important;
}
</style>